(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalSelfMarkInput = {
    attach(context) {
      // Toggle self mark submit button.
      const selfMarkInputSelector = ".self-marks__marks input";
      const formActionsSelector = ".form-actions--score";
      const buttonSelector = ".btn";

      $(selfMarkInputSelector, context).on("keyup", function () {
        const $input = $(this);
        const $actions = $(formActionsSelector);
        const value = $input.val();

        if (!value) {
          $actions.addClass("form-actions--score--disabled");
          return;
        }

        // If the URL already contains the 'past_paper' parameter,
        // the 'marks' parameter will be added to the URL.
        $actions.removeClass("form-actions--score--disabled");
        const $button = $actions.find(buttonSelector);
        const url = $button.attr("href");
        const urlQuery = url.includes("past_paper")
          ? `${url}&marks=${value}`
          : `${url.split("?")[0]}?marks=${value}`;

        $button.attr("href", urlQuery);
      });
    },
  };
})(jQuery, Drupal);
